<template><ProductDetailBase route-key="/products/special" /></template>
<script>
import ProductDetailBase from "./ProductDetailBase.vue";
export default { name: "SpecialTransformerPage", components: { ProductDetailBase } };
</script>
